// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  ExecutionContext,
  ExecutionContextFromJSON,
  ExecutionContextToJSON,
  StepWiseResult,
  StepWiseResultFromJSON,
  StepWiseResultToJSON,
  TestDatasetWiseResult,
  TestDatasetWiseResultFromJSON,
  TestDatasetWiseResultToJSON,
} from "./";

/**
 *
 * @export
 * @interface ExecutedTestCasePayload
 */
export interface ExecutedTestCasePayload {
  /**
   *
   * @type {number}
   * @memberof ExecutedTestCasePayload
   */
  id?: number;
  /**
   * Test Plan's Test Case ID
   * @type {number}
   * @memberof ExecutedTestCasePayload
   */
  testPlanTestCase: number;
  /**
   * Test case revision id
   * @type {number}
   * @memberof ExecutedTestCasePayload
   */
  testCaseRevision?: number;
  /**
   * Project ID
   * @type {number}
   * @memberof ExecutedTestCasePayload
   */
  project: number;
  /**
   * Test plan ID
   * @type {number}
   * @memberof ExecutedTestCasePayload
   */
  testPlan: number;
  /**
   * Test Plan's Configuration ID
   * @type {number}
   * @memberof ExecutedTestCasePayload
   */
  testPlanConfig?: number;
  /**
   * Executed test case assigned to
   * @type {number}
   * @memberof ExecutedTestCasePayload
   */
  assignedTo?: number;
  /**
   * Test Plan Regression's  ID
   * @type {number}
   * @memberof ExecutedTestCasePayload
   */
  regression?: number;
  /**
   *
   * @type {string}
   * @memberof ExecutedTestCasePayload
   */
  comment?: string;
  /**
   * Array of file ids
   * @type {Array<string>}
   * @memberof ExecutedTestCasePayload
   */
  attachments?: Array<string>;
  /**
   * System name of the status, used for internal references
   * @type {string}
   * @memberof ExecutedTestCasePayload
   */
  status?: string;
  /**
   * Number of seconds taken for this test
   * @type {number}
   * @memberof ExecutedTestCasePayload
   */
  timeTaken?: number;
  /**
   *
   * @type {Array<StepWiseResult>}
   * @memberof ExecutedTestCasePayload
   */
  stepWiseResult?: Array<StepWiseResult>;
  /**
   *
   * @type {Array<TestDatasetWiseResult>}
   * @memberof ExecutedTestCasePayload
   */
  testdatasetWiseResult?: Array<TestDatasetWiseResult>;
  /**
   * TCV-6814. How this result was produced: manual (a person in the app), ci (a pipeline), api (a token-authenticated caller that did not say more), agent (QA Copilot or another agent) or import. Null on results recorded before this was tracked — absent rather than guessed.
   * @type {string}
   * @memberof ExecutedTestCasePayload
   */
  executionSource?: ExecutedTestCasePayloadExecutionSourceEnum;
  /**
   *
   * @type {ExecutionContext}
   * @memberof ExecutedTestCasePayload
   */
  executionContext?: ExecutionContext;
}

export function ExecutedTestCasePayloadFromJSON(
  json: any
): ExecutedTestCasePayload {
  return {
    id: !exists(json, "id") ? undefined : json["id"],
    testPlanTestCase: json["test_plan_test_case"],
    testCaseRevision: !exists(json, "test_case_revision")
      ? undefined
      : json["test_case_revision"],
    project: json["project"],
    testPlan: json["test_plan"],
    testPlanConfig: !exists(json, "test_plan_config")
      ? undefined
      : json["test_plan_config"],
    assignedTo: !exists(json, "assigned_to") ? undefined : json["assigned_to"],
    regression: !exists(json, "regression") ? undefined : json["regression"],
    comment: !exists(json, "comment") ? undefined : json["comment"],
    attachments: !exists(json, "attachments") ? undefined : json["attachments"],
    status: !exists(json, "status") ? undefined : json["status"],
    timeTaken: !exists(json, "time_taken") ? undefined : json["time_taken"],
    stepWiseResult: !exists(json, "step_wise_result")
      ? undefined
      : (json["step_wise_result"] as Array<any>).map(StepWiseResultFromJSON),
    testdatasetWiseResult: !exists(json, "testdataset_wise_result")
      ? undefined
      : (json["testdataset_wise_result"] as Array<any>).map(
          TestDatasetWiseResultFromJSON
        ),
    executionSource: !exists(json, "execution_source")
      ? undefined
      : json["execution_source"],
    executionContext: !exists(json, "execution_context")
      ? undefined
      : ExecutionContextFromJSON(json["execution_context"]),
  };
}

export function ExecutedTestCasePayloadToJSON(
  value?: ExecutedTestCasePayload
): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    id: value.id,
    test_plan_test_case: value.testPlanTestCase,
    test_case_revision: value.testCaseRevision,
    project: value.project,
    test_plan: value.testPlan,
    test_plan_config: value.testPlanConfig,
    assigned_to: value.assignedTo,
    regression: value.regression,
    comment: value.comment,
    attachments: value.attachments,
    status: value.status,
    time_taken: value.timeTaken,
    step_wise_result:
      value.stepWiseResult === undefined
        ? undefined
        : (value.stepWiseResult as Array<any>).map(StepWiseResultToJSON),
    testdataset_wise_result:
      value.testdatasetWiseResult === undefined
        ? undefined
        : (value.testdatasetWiseResult as Array<any>).map(
            TestDatasetWiseResultToJSON
          ),
    execution_source: value.executionSource,
    execution_context: ExecutionContextToJSON(value.executionContext),
  };
}

/**
 * @export
 * @enum {string}
 */
export enum ExecutedTestCasePayloadExecutionSourceEnum {
  Manual = "manual",
  Ci = "ci",
  Api = "api",
  Agent = "agent",
  Import = "import",
}
